import { type Meter } from '../meters/meter-types'
import type FilterOption from '../../interfaces/FilterOption'

export enum CustomerFilterType {
  All = 'All',
  ById = 'ById'
}

interface CustomerFilterByType {
  type: CustomerFilterType.ById
  companyId: string
}

interface CustomerFilterAll {
  type: CustomerFilterType.All
}

export type CustomerFilter = CustomerFilterAll | CustomerFilterByType

export interface DataState {
  meters: Meter[]
  alarmsFilter: boolean
  customerFilter: CustomerFilter
  idFilter: string
  filteredMeters: Meter[]
  activeFilters: FilterOption[]
  searchText: string
  labelFilters: string[]
}
